export const visit = (vm, at) => {
vm(require("foundations-components/lang/sl.lyaml"));
at({ "sl": { "placeholder": "nadomestni znak" } });
};